// Funcionalidades específicas para a página de busca
document.addEventListener("DOMContentLoaded", () => {
  initSearchPage();
});

function initSearchPage() {
  // Verificar se estamos na página de busca
  if (!document.querySelector(".search")) return;

  updateResultsCount();
  handleEmptyResults();
  initSortingControls();
}

/**
 * Atualiza a contagem de resultados exibindo apenas produtos
 */
function updateResultsCount() {
  const resultsCountElement = document.querySelector(".search__results-count");
  const productItems = document.querySelectorAll(".search__products > div");

  if (resultsCountElement && productItems) {
    const count = productItems.length;
    resultsCountElement.textContent = `${count} produto(s) encontrado(s)`;
  }
}

/**
 * Melhora a experiência quando não há resultados
 */
function handleEmptyResults() {
  const noResultsElement = document.querySelector(".search__no-results");

  if (noResultsElement) {
    // Adicionar sugestões populares ou categorias quando não há resultados
    const searchTerm = new URLSearchParams(window.location.search).get("q");

    // Adicionar link para voltar à página inicial
    const homeLink = document.createElement("a");
    homeLink.href = "/";
    homeLink.className = "search__home-link";
    homeLink.textContent = "Voltar para a página inicial";
    homeLink.style.display = "inline-block";
    homeLink.style.marginTop = "20px";
    homeLink.style.padding = "10px 20px";
    homeLink.style.backgroundColor = "var(--primary-color, #333)";
    homeLink.style.color = "#fff";
    homeLink.style.borderRadius = "4px";

    noResultsElement.appendChild(homeLink);
  }
}

/**
 * Inicializa os controles de ordenação na página de busca
 */
function initSortingControls() {
  const sortSelect = document.querySelector(".search__sort-select");
  if (!sortSelect) return;

  // Obter o valor atual da URL se existir
  const urlParams = new URLSearchParams(window.location.search);
  const currentSort = urlParams.get("sort_by");

  // Definir o valor selecionado com base na URL
  if (currentSort) {
    sortSelect.value = currentSort;
  }

  // Adicionar evento de mudança
  sortSelect.addEventListener("change", function () {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("sort_by", this.value);

    // Manter o parâmetro de busca e página atual
    const q = searchParams.get("q");
    if (!q) {
      const searchTerms = document
        .querySelector(".search__title")
        ?.textContent.replace("Resultados para: ", "")
        .trim();
      if (searchTerms) searchParams.set("q", searchTerms);
    }

    // Redirecionar para a mesma página com os novos parâmetros
    window.location.href = `${
      window.location.pathname
    }?${searchParams.toString()}`;
  });

  // Garantir que a ordenação seja aplicada corretamente
  setTimeout(() => {
    // Aplicar ordenação aos resultados já carregados (para ordenação client-side)
    applyClientSideSorting(sortSelect.value);
  }, 100);
}

/**
 * Aplica ordenação do lado do cliente aos resultados da busca
 * @param {string} sortBy - Critério de ordenação
 */
function applyClientSideSorting(sortBy) {
  const productsContainer = document.querySelector(".search__products");
  if (!productsContainer) return;

  // Não aplicar ordenação client-side quando estamos usando paginação
  // A ordenação deve ser feita pelo servidor através dos parâmetros da URL
  if (document.querySelector(".search__pagination")) return;

  const productItems = Array.from(productsContainer.children).filter(
    (item) =>
      item.hasAttribute("role") && item.getAttribute("role") === "listitem"
  );

  if (productItems.length <= 1) return; // Não precisa ordenar se tiver apenas um item

  // Se não houver critério de ordenação definido, não fazer nada
  if (!sortBy || sortBy === "relevance") return;

  // Criar um array temporário para não modificar o DOM enquanto ordena
  const tempItems = [...productItems];

  // Ordenar os itens com base no critério selecionado
  tempItems.sort((a, b) => {
    const productA = a.querySelector(".product-card");
    const productB = b.querySelector(".product-card");

    if (!productA || !productB) return 0;

    const titleA =
      productA.querySelector(".product-card__title")?.textContent.trim() || "";
    const titleB =
      productB.querySelector(".product-card__title")?.textContent.trim() || "";

    // Melhorar a extração do preço para evitar erros
    let priceA = 0;
    let priceB = 0;

    const priceElementA = productA.querySelector(".product-card__price");
    const priceElementB = productB.querySelector(".product-card__price");

    if (priceElementA) {
      const priceTextA = priceElementA.textContent.trim();
      priceA =
        parseFloat(
          priceTextA
            .replace(/[^0-9,.]/g, "")
            .replace(".", "")
            .replace(",", ".")
        ) || 0;
    }

    if (priceElementB) {
      const priceTextB = priceElementB.textContent.trim();
      priceB =
        parseFloat(
          priceTextB
            .replace(/[^0-9,.]/g, "")
            .replace(".", "")
            .replace(",", ".")
        ) || 0;
    }

    switch (sortBy) {
      case "price-ascending":
        return priceA - priceB;
      case "price-descending":
        return priceB - priceA;
      case "title-ascending":
        return titleA.localeCompare(titleB, "pt-BR");
      case "title-descending":
        return titleB.localeCompare(titleA, "pt-BR");
      default: // relevance - manter a ordem original
        return 0;
    }
  });

  // Limpar o container antes de adicionar os itens ordenados
  while (productsContainer.firstChild) {
    productsContainer.removeChild(productsContainer.firstChild);
  }

  // Adicionar os itens ordenados de volta ao DOM
  tempItems.forEach((item) => productsContainer.appendChild(item));

  // Atualizar a contagem após a ordenação
  updateResultsCount();
}
